"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var promisedComputed_1 = require("./promisedComputed");
var throttledComputed_1 = require("./throttledComputed");
var ComputedAsync = /** @class */ (function () {
    function ComputedAsync(options) {
        var _this = this;
        this.options = options;
        if (options.delay) {
            this.computation = throttledComputed_1.throttledComputed(options.fetch, options.delay);
        }
        else {
            this.computation = mobx_1.computed(options.fetch);
        }
        this.promised = promisedComputed_1.promisedComputedInternal(options.init, function () { return _this.computation.get(); });
    }
    Object.defineProperty(ComputedAsync.prototype, "busy", {
        get: function () {
            return this.promised.busy;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedAsync.prototype, "failed", {
        get: function () {
            try {
                this.promised.get();
                return false;
            }
            catch (x) {
                return true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedAsync.prototype, "error", {
        get: function () {
            try {
                this.promised.get();
                return undefined;
            }
            catch (x) {
                return x;
            }
        },
        enumerable: true,
        configurable: true
    });
    ComputedAsync.prototype.initializedValue = function () {
        this.lastValue = this.promised.get();
        return this.lastValue; // this.lastValue === undefined ? this.options.init : this.lastValue;
    };
    Object.defineProperty(ComputedAsync.prototype, "value", {
        get: function () {
            if (this.promised.busy && this.options.revert) {
                return this.options.init;
            }
            if (this.options.rethrow) {
                return this.initializedValue();
            }
            try {
                return this.initializedValue();
            }
            catch (x) {
                if (this.options.error) {
                    try {
                        return this.options.error(x);
                    }
                    catch (x) {
                        console.error(x);
                    }
                }
                return this.lastValue === undefined ? this.options.init : this.lastValue;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], ComputedAsync.prototype, "failed", null);
    __decorate([
        mobx_1.computed
    ], ComputedAsync.prototype, "error", null);
    __decorate([
        mobx_1.computed
    ], ComputedAsync.prototype, "value", null);
    return ComputedAsync;
}());
function computedAsync(init, fetch, delay) {
    if (arguments.length === 1) {
        return new ComputedAsync(init);
    }
    return new ComputedAsync({
        init: init,
        fetch: fetch,
        delay: delay
    });
}
exports.computedAsync = computedAsync;
//# sourceMappingURL=deprecatedComputedAsync.js.map